import type { ProductTab } from '@/types/domains/ProductTabType';

/**
 * トップ「人気の商品ランキング」のタブ。支給デザインの `products-tab-btn`（`data-tab`）5本に対応する。
 *
 * - 「すべて」は `is_top` が立っている商品を出す（決定#31）。全件でも支給HTMLの
 *   `data-pickup="true"`（37枚中8枚）でもなく、現行トップの掲載商品と同じ母集団・同じ並び順になる。
 *   絞り込みは obbs_api 側（`/productContents/top`）で済んでいる
 * - 残る4本は `is_top` に関係なく全商品からカテゴリで絞る。よって「すべて」は4本の和集合ではない
 * - 「すべて」だけアイコンを持たずテキストのみ。残る4本はアイコン2枚（`icon-on` / `icon-off`）＋ラベル
 * - 「食品」は obbs_api がカテゴリを払い出さないので、`PRODUCT_CODE_TO_CATEGORY_ID` による補正
 *   （`useProductContent` の `resolveCategoryId`）でのみ `categoryId: 4` が付く
 * - `iconModifier` の `mt-12` は支給CSSでは `@media (max-width: 768px)` にしか定義が無く、PCでは効かない
 */
export const PRODUCT_TABS: ReadonlyArray<ProductTab> = [
  {
    // `id` は支給デザインの `data-tab` 値なので `all` のまま。母集団は `categoryId` が決める
    id: 'all',
    label: 'すべて',
    categoryId: 'top',
    iconName: null,
    iconModifier: '',
  },
  {
    // `id`（支給の `data-tab`）とアイコンは画像ファイル名・CSSセレクタなので、slug の改名に追随させない
    id: 'functional-food',
    label: 'サプリメント',
    categoryId: 1,
    iconName: 'functional-food',
    iconModifier: 'functional-food mt-12',
  },
  {
    id: 'food',
    label: '食品',
    categoryId: 4,
    iconName: 'food',
    iconModifier: '',
  },
  {
    id: 'skincare',
    label: 'スキンケア',
    categoryId: 2,
    iconName: 'skincare',
    iconModifier: '',
  },
  {
    id: 'personalcare',
    label: 'パーソナル<br class="sp-only" />ケア',
    categoryId: 3,
    iconName: 'personalcare',
    iconModifier: 'mt-12',
  },
] as const;
